// extracted by mini-css-extract-plugin
module.exports = {"form":"FormMessageBubble_form__2q5DP","input":"FormMessageBubble_input__3U5FC"};